<!-- <app-employee-menu> </app-employee-menu> -->

<div class="staff-component-container page-root-container">

        <div class="page-header">
                <div class="page-title">

                        <img class="icon" src="assets/images/menu/svg/kitchen.svg"><span class="title">Staff
                                Attendance</span>
                </div>
                <div class="page-actions">
                        @if(permission.can_export || permission.can_execute){
                        <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                        </button>
                        }
                        @if(permission.can_add){
                        <button mat-button color="primary" class="btn-add"
                                (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
                        }

                        <!-- <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                          </button> -->
                </div>
        </div>

        <div class="data-container ">
                <app-loader [show]="isLoading"></app-loader>

                <!-- DROPDOWNS SECTION -->
                <form [formGroup]="editForm">
                        <div class="attendance-filter-bar"
                                style="display: flex; gap: 1rem; align-items: center; margin-bottom: 1rem; width: 100%;">
                                <mat-form-field appearance="fill" class="filter-dropdown employee-dropdown">
                                        <mat-label>Employee</mat-label>
                                        <input matInput formControlName="employee" [matAutocomplete]="employeeAuto"
                                                (input)="filterEmployees()" (focus)="filterEmployees()"
                                                autocomplete="off" placeholder="Select an employee">

                                        <span matSuffix class="suffix-icons" style="position: relative;">
                                                <button *ngIf="editForm.get('employee')?.value" mat-icon-button
                                                        aria-label="Clear" class="close-icon-btn"
                                                        (click)="clearEmployee()">
                                                        <mat-icon class="small-icon"
                                                                style="color: rgb(161, 155, 155);">close</mat-icon>
                                                </button>
                                                <button mat-icon-button aria-label="Browse Employees"
                                                        class="search-icon-btn" (click)="openEmployeeBrowseDialog()"
                                                        style="position: relative;">
                                                        <mat-icon>person_search</mat-icon>
                                                        <span *ngIf="getSelectedEmployeeCount() > 0"
                                                                class="employee-badge" style="
              position: absolute;
              top: 2px;
              right: 2px;
              background: #e53935;
              color: #fff;
              border-radius: 50%;
              font-size: 11px;
              width: 18px;
              height: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0;
              z-index: 2;
              box-sizing: border-box;
              line-height: 18px;
              font-weight: 600;
            ">
                                                                {{ getSelectedEmployeeCount() }}
                                                        </span>
                                                </button>
                                        </span>

                                        <mat-autocomplete #employeeAuto="matAutocomplete"
                                                [displayWith]="displayEmployee"></mat-autocomplete>
                                </mat-form-field>

                                <mat-form-field appearance="fill" class="filter-dropdown year-dropdown">
                                        <mat-label>Year</mat-label>
                                        <mat-select placeholder="Select a year" formControlName="year"
                                                (selectionChange)="onYearChange()">
                                                <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                                                        {{ fy.display_year }}
                                                </mat-option>
                                        </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="filter-dropdown week-dropdown">
                                        <mat-label>Week No</mat-label>
                                        <mat-select multiple formControlName="week_no"
                                                (selectionChange)="onWeekChange($event)">
                                                <mat-option *ngIf="showThisLastOption" [value]="'this_last'">This week &
                                                        Last week</mat-option>
                                                <mat-option *ngFor="let week of weeks" [value]="week">
                                                        {{ week.displayText }}
                                                </mat-option>
                                        </mat-select>
                                </mat-form-field>
                                <div class="search-filter-container" style=" min-width:120px; width:100%;">
                                        <app-search-filter #searchFilter [pagingData]="pagingData"
                                                [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter"
                                                (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                                                [hidePageSize]="true" [hideAdvancedFilter]="true">
                                        </app-search-filter>
                                </div>
                        </div>
                </form>

                <!-- <app-search-filter #searchFilter [length]="pagingData.length" [pageSize]="pagingData.pageSize"
                        [pageSizeOptions]="[5,10,20,50,100]" [pageIndex]="pagingData.pageIndex" [filter]="filter"
                        (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"  [hidePageSize]="true">
                </app-search-filter> -->

                <!-- <ng-container *ngIf="pagingData.length>0; else nodata"> -->
                <!-- @if(pagingData.length > 0){
                                @if(!isHandset){ -->
                <section tabindex="0" class="table-container">
                        <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                                <ng-container matColumnDef="sl" sticky>
                                        <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2"
                                                style="width: 30px; max-width: 30px;">#</th>
                                        <td mat-cell *matCellDef="let row; let i = index"
                                                style="width: 30px; max-width: 30px;">
                                                {{ (pagingData.pageIndex * pagingData.pageSize) + i + 1 }}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="employee_name" sticky>
                                        <th mat-sort-header="F_name" mat-header-cell *matHeaderCellDef
                                                [attr.rowspan]="2">Employee</th>
                                        <td mat-cell *matCellDef="let row">{{ row.employee_name }} {{ row.employee_lname
                                                }}</td>
                                </ng-container>
                                <ng-container matColumnDef="station_code">
                                        <th mat-sort-header="s.code" mat-header-cell *matHeaderCellDef
                                                [attr.rowspan]="2" style="width: 90px; max-width: 90px;">Terminal</th>
                                        <td mat-cell *matCellDef="let row" style="width: 140px; max-width: 140px;">{{
                                                row.station_code }}</td>
                                </ng-container>
                                <ng-container matColumnDef="shift_start_date">
                                        <th mat-sort-header="shift_start_date" mat-header-cell *matHeaderCellDef
                                                [attr.rowspan]="2" style="width: 115px; max-width: 115px;">Start Date
                                        </th>
                                        <td mat-cell *matCellDef="let row" style="width: 120px; max-width: 120px;">{{
                                                row.shift_start_date }}</td>
                                </ng-container>

                                <ng-container matColumnDef="shift_start_time_group">
                                        <th mat-header-cell *matHeaderCellDef colspan="2" style="text-align: center;">
                                                Start Time</th>
                                </ng-container>
                                <ng-container matColumnDef="shift_end_date">
                                        <th mat-sort-header="shift_end_date" style="width: 120px;" mat-header-cell
                                                *matHeaderCellDef [attr.rowspan]="2">End Date</th>
                                        <td mat-cell *matCellDef="let row">{{ row.shift_end_date }}</td>
                                </ng-container>
                                <ng-container matColumnDef="shift_end_time_group">
                                        <th mat-header-cell *matHeaderCellDef colspan="2" style="text-align: center;">
                                                End Time</th>
                                </ng-container>
                                <ng-container matColumnDef="shift_start_time">
                                        <th mat-sort-header="shift_start_time" style="width: 80px;" mat-header-cell
                                                *matHeaderCellDef>Rounded</th>
                                        <td mat-cell *matCellDef="let row">
                                                {{ formatTime(row.shift_start_time) }}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="act_shift_start_time">
                                        <th mat-sort-header="act_shift_start_time" style="width: 80px;" mat-header-cell
                                                *matHeaderCellDef>Actual</th>
                                        <td mat-cell *matCellDef="let row">
                                                {{ formatTime(row.act_shift_start_time) }}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="shift_end_time">
                                        <th mat-sort-header="shift_end_time" style="width: 80px;" mat-header-cell
                                                *matHeaderCellDef>Rounded</th>
                                        <td mat-cell *matCellDef="let row">
                                                {{ formatTime(row.shift_end_time) }}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="act_shift_end_time">
                                        <th mat-sort-header="act_shift_end_time" style="width: 80px;" mat-header-cell
                                                *matHeaderCellDef>Actual</th>
                                        <td mat-cell *matCellDef="let row">
                                                {{ formatTime(row.act_shift_end_time) }}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="is_finalized_by">
                                        <th mat-sort-header="u.name" mat-header-cell *matHeaderCellDef
                                                [attr.rowspan]="2" style="width: 150px; max-width: 150px;">Finalized By
                                        </th>
                                        <td mat-cell *matCellDef="let row" style="width: 150px; max-width: 150px;">
                                                <div
                                                        style="display: flex; align-items: center; gap: 8px; justify-content: flex-start; height: 100%;">
                                                        <ng-container *ngIf="row.is_finalized; else notFinalized">
                                                                <span
                                                                        style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; color: #fff; font-weight: bold; font-size: 16px; background: #43a047;">
                                                                        A
                                                                </span>
                                                        </ng-container>
                                                        <ng-template #notFinalized>
                                                                <button mat-icon-button (click)="onFinalized(row)"
                                                                        style="padding:0; background:transparent;margin-left: -10px;">
                                                                        <span style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; color: #fff; font-weight: bold; font-size: 16px; "
                                                                                [ngStyle]="{'background': '#e53935'}">
                                                                                A
                                                                        </span>
                                                                </button>
                                                        </ng-template>
                                                        <span style="margin-left: 6px;">{{ row.finalized_by_name || '-'
                                                                }}</span>
                                                </div>
                                        </td>
                                </ng-container>
                                <!-- <ng-container matColumnDef="is_finalized">
                                        <th mat-sort-header="is_finalized" mat-header-cell *matHeaderCellDef [attr.rowspan]="2" class="finalized-header">Finalized</th>
                                        <td mat-cell *matCellDef="let row">
        <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
            <button
                *ngIf="!row.is_finalized"
                mat-icon-button
                (click)="onFinalized(row)"
                style="padding:0; background:transparent;">
                <span 
                    style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; color: #fff; font-weight: bold; font-size: 16px;"
                    [ngStyle]="{'background': '#e53935'}">
                    A
                </span>
            </button>
            <span
                *ngIf="row.is_finalized"
                style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; color: #fff; font-weight: bold; font-size: 16px; background: #43a047;">
                A
            </span>
        </div>
    </td>
                                </ng-container> -->
                                <ng-container matColumnDef="delete">
                                        <th mat-header-cell *matHeaderCellDef
                                                style="width: 40px; min-width: 40px; max-width: 40px; padding: 0;"
                                                [attr.rowspan]="2"></th>
                                        <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                                                <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                                                        (click)="onRowSelected(rowItem);$event.stopPropagation();">
                                                        <mat-icon>more_vert</mat-icon>
                                                </a>

                                                <mat-menu #rowMenu>
                                                        @if(permission.can_delete){
                                                        <button mat-menu-item
                                                                (click)="onDelete(rowItem)">Delete</button>
                                                        }
                                                        @if(permission.can_edit){
                                                        <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                                                        }
                                                </mat-menu>
                                </ng-container>


                                <!-- Header Rows -->
                                <tr mat-header-row
                                        *matHeaderRowDef="['sl', 'employee_name', 'station_code', 'shift_start_date', 'shift_start_time_group','shift_end_date', 'shift_end_time_group',  'is_finalized_by', 'delete']; sticky: true">
                                </tr>
                                <tr mat-header-row
                                        *matHeaderRowDef="['shift_start_time', 'act_shift_start_time', 'shift_end_time', 'act_shift_end_time']; sticky: true">
                                </tr>
                                <!-- Data Rows -->
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        @if(pagingData.length<=0){ <div class="no-data-container">
                                <img src="assets/images/no-data.png">
                                <span class="no-data-info">No data found. Please remove or redefine the filters if
                                        any.</span>
        </div>
        }
        </section>
        <!-- @if(pagingData.length <= 0){ -->
</div>
</div>